import { windowPresent } from './window';

declare global {
  interface Window {
    hj?: any;
  }
}

// Fallback function in case an event is fired before the Hotjar Tracking Code has executed.
// Based on: https://help.hotjar.com/hc/en-us/articles/4405109971095-Events-API-Reference#best_practices
function hj(...rest: string[]) {
  (window.hj.q = window.hj.q || []).push(rest);
}

export function hotjarEvent(eventName: string) {
  if (windowPresent) {
    window.hj = window.hj || hj;
    window.hj('event', eventName);
  }
}
